import { Box, styled, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type StandaloneBadgeSize = 'medium' | 'small';

const SMALL_BADGE_HEIGHT = '1.0625rem';

const StandaloneBadgeContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: StandaloneBadgeSize }>(({ theme, size }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  minWidth: '1.5rem',
  height: '1.25rem',
  padding: `0 ${theme.spacing(1)}`,
  backgroundColor: theme.palette.custom.OV.sys.surfaceVariant,
  color: theme.palette.custom.OV.sys.onSurface,
  borderRadius: '6.25rem',
  ...(size === 'small' && {
    minWidth: 0,
    height: SMALL_BADGE_HEIGHT,
    padding: '0 0.375rem',
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
  }),
}));

/** `small` is the quieter count that sits beside a section heading. */
export const StandaloneBadge = ({
  badgeContent,
  size = 'medium',
}: {
  badgeContent: ReactNode;
  size?: StandaloneBadgeSize;
}) => {
  return (
    <StandaloneBadgeContainer size={size}>
      {size === 'small' ? (
        <Typography
          component="span"
          fontSize="0.6875rem"
          fontWeight={600}
          lineHeight={SMALL_BADGE_HEIGHT}
        >
          {badgeContent}
        </Typography>
      ) : (
        <Typography variant="body1" fontSize="small" component="span">
          {badgeContent}
        </Typography>
      )}
    </StandaloneBadgeContainer>
  );
};
